import { Components, Palette } from '@mui/material';

export const createCommonComponentsOverrides = (
	palette: Palette
): Components => ({
	MuiAppBar: {
		styleOverrides: {
			root: {
				backgroundColor: palette.background.paper,
				color: palette.text.primary
			}
		}
	},
	MuiButton: {
		variants: [
			{
				props: { variant: 'outlined' },
				style: {
					borderColor: 'primary.main'
				}
			}
		],
		styleOverrides: {
			root: {
				borderRadius: 30,
				textTransform: 'none'
			}
		}
	},
	MuiAlert: {
		styleOverrides: {
			root: {
				borderRadius: 13
			}
		}
	},
	MuiTooltip: {
		styleOverrides: {
			tooltip: {
				backgroundColor: palette.mode === 'dark' ? palette.grey[300] : undefined
			}
		}
	},
	MuiDialog: {
		styleOverrides: {
			paper: {
				backgroundColor: palette.mainPaperBackground,
				borderColor:
					palette.mode === 'dark' ? palette.grey[300] : 'transparent',
				borderWidth: '1px',
				borderStyle: 'solid',
				borderRadius: 15
			}
		}
	},
	MuiCardActionArea: {
		defaultProps: {
			disableRipple: true
		},
		styleOverrides: {
			root: {
				':hover': {
					background: 'transparent'
				}
			},
			focusHighlight: {
				variants: [
					{
						props: { disabled: true },
						style: {
							backgroundColor: palette.grey[100],
							opacity: 0.6
						}
					}
				],
				backgroundColor: 'transparent'
			}
		}
	}
});
